import { addMultipleViewForm as addMultipleViewFormFunc } from "./addMultipleViewForm/addMultipleViewForm";
import { benchmark as benchmarkFunc } from "./benchmark/benchmark";
import { description as descriptionFunc } from "./description/description";
import { dynamicHeatMap as dynamicHeatMapFunc } from "./dynamicHeatMap/dynamicHeatMap";
import { gridTopFilterFunc } from "./gridTopFilter/gridTopFilter";
import { heatMap as heatMapFunc } from "./heatMap/heatMap";
import { highchartsMultipleMeasures as highchartsMultipleMeasuresFunc, highchartsMultipleMeasuresSideBySide as highchartsMultipleMeasuresSideBySideFunc } from "./highcharts-multiple-measures/highchartsMultipleMeasures";
import { highchartsOneMeasure as highchartsOneMeasureFunc } from "./highcharts-one-measure/highchartsOneMeasure";
import { highchartsRadarChart as highchartsRadarChartFunc } from "./highcharts-radarchart/highchartsRadarChart";
import { highchartsTimeSeries as highchartsTimeSeriesFunc, customCategoriesTimeseries as customCategoriesTimeseriesFunc, staticCategoriesTimeseries as staticCategoriesTimeseriesFunc } from "./highcharts-timeseries/highchartsTimeSeries";
import { highchartsTimeSeriesCreation as highchartsTimeSeriesCreationFunc } from "./highcharts-timeseries/highchartsTimeSeriesCreation";
import { horizontalStackedBarChart as horizontalStackedBarChartFunc } from "./horizontal-stacked-bar-chart/horizontalStackedBarChart";
import { kpi as kpiFunc } from "./kpi/kpi";
import { map as mapFunc } from "./map";
import { scatterPlot as scatterPlotFunc } from "./scatterPlot/scatterPlot";
import { bubbleChart as bubbleChartFunc } from "./bubbleChart/bubbleChart";
import { stackedColumnChart as stackedColumnChartFunc } from "./stacked-column-chart/stackedColumnChart";
import { valueBridge as valueBridgeFunc } from "./valueBridge/valueBridge";
import { valuePair as valuePairFunc } from "./valuePair/valuePair";
import { addTotalSeriesVisitor as addTotalSeriesVisitorFunc } from "./horizontal-stacked-bar-chart/addTotalSeriesVisitor";
import { addTotalFlatLineSeriesVisitor as addTotalFlatLineSeriesVisitorFunc } from "./stacked-column-chart/addTotalFlatLineSeriesVisitor";
export var CustomVisitorEnum;
(function (CustomVisitorEnum) {
    CustomVisitorEnum["highchartsTimeSeries"] = "highchartsTimeSeries";
    CustomVisitorEnum["valuePair"] = "valuePair";
    CustomVisitorEnum["highchartsRadarChart"] = "highchartsRadarChart";
    CustomVisitorEnum["valueBridge"] = "valueBridge";
    CustomVisitorEnum["addMultipleViewForm"] = "addMultipleViewForm";
    CustomVisitorEnum["highchartsOneMeasure"] = "highchartsOneMeasure";
    CustomVisitorEnum["highchartsMultipleMeasures"] = "highchartsMultipleMeasures";
    CustomVisitorEnum["description"] = "description";
    CustomVisitorEnum["kpi"] = "kpi";
    CustomVisitorEnum["map"] = "map";
    CustomVisitorEnum["scatterPlot"] = "scatterPlot";
    CustomVisitorEnum["bubbleChart"] = "bubbleChart";
    CustomVisitorEnum["horizontalStackedBarChart"] = "horizontalStackedBarChart";
    CustomVisitorEnum["highchartsTimeSeriesCreation"] = "highchartsTimeSeriesCreation";
    CustomVisitorEnum["highchartsMultipleMeasuresSideBySide"] = "highchartsMultipleMeasuresSideBySide";
    CustomVisitorEnum["benchmark"] = "benchmark";
    CustomVisitorEnum["gridTopFilter"] = "gridTopFilter";
    CustomVisitorEnum["stackedColumnChart"] = "stackedColumnChart";
    CustomVisitorEnum["heatMap"] = "heatMap";
    CustomVisitorEnum["dynamicHeatMap"] = "dynamicHeatMap";
    CustomVisitorEnum["customCategoriesTimeseries"] = "customCategoriesTimeseries";
    CustomVisitorEnum["staticCategoriesTimeseries"] = "staticCategoriesTimeseries";
    CustomVisitorEnum["addTotalSeriesVisitor"] = "addTotalSeriesVisitor";
    CustomVisitorEnum["addTotalFlatLineSeriesVisitor"] = "addTotalFlatLineSeriesVisitor";
})(CustomVisitorEnum || (CustomVisitorEnum = {}));
export const CustomVisitors = {
    [CustomVisitorEnum.highchartsTimeSeries]: {
        visitor: (args) => highchartsTimeSeriesFunc(args)
    },
    [CustomVisitorEnum.highchartsTimeSeriesCreation]: {
        visitor: (args) => highchartsTimeSeriesCreationFunc(args)
    },
    [CustomVisitorEnum.valuePair]: {
        visitor: (args) => valuePairFunc(args)
    },
    [CustomVisitorEnum.highchartsRadarChart]: {
        visitor: (args) => highchartsRadarChartFunc(args)
    },
    [CustomVisitorEnum.valueBridge]: {
        visitor: (args) => valueBridgeFunc(args)
    },
    [CustomVisitorEnum.addMultipleViewForm]: {
        visitor: () => addMultipleViewFormFunc()
    },
    [CustomVisitorEnum.highchartsOneMeasure]: {
        visitor: (args) => highchartsOneMeasureFunc(args)
    },
    [CustomVisitorEnum.highchartsMultipleMeasures]: {
        visitor: (args) => highchartsMultipleMeasuresFunc(args)
    },
    [CustomVisitorEnum.description]: {
        visitor: (args) => descriptionFunc(args)
    },
    [CustomVisitorEnum.kpi]: {
        visitor: (args) => kpiFunc(args[0], args?.[1])
    },
    [CustomVisitorEnum.map]: {
        visitor: (args) => mapFunc(args[0])
    },
    [CustomVisitorEnum.scatterPlot]: {
        visitor: (args) => scatterPlotFunc(args[0])
    },
    [CustomVisitorEnum.bubbleChart]: {
        visitor: (args) => bubbleChartFunc(args[0])
    },
    [CustomVisitorEnum.horizontalStackedBarChart]: {
        visitor: (args) => horizontalStackedBarChartFunc(args)
    },
    [CustomVisitorEnum.highchartsMultipleMeasuresSideBySide]: {
        visitor: (args) => highchartsMultipleMeasuresSideBySideFunc(args)
    },
    [CustomVisitorEnum.benchmark]: {
        visitor: (args) => benchmarkFunc(args[0], args[1], args?.[2])
    },
    [CustomVisitorEnum.gridTopFilter]: {
        visitor: (args) => gridTopFilterFunc(args?.[0], args?.[1], args?.[2])
    },
    [CustomVisitorEnum.stackedColumnChart]: {
        visitor: (args) => stackedColumnChartFunc(args[0])
    },
    [CustomVisitorEnum.heatMap]: {
        visitor: (args) => heatMapFunc(args[0])
    },
    [CustomVisitorEnum.dynamicHeatMap]: {
        visitor: (args) => dynamicHeatMapFunc(args[0])
    },
    [CustomVisitorEnum.customCategoriesTimeseries]: {
        visitor: (args) => customCategoriesTimeseriesFunc(args[0])
    },
    [CustomVisitorEnum.staticCategoriesTimeseries]: {
        visitor: (args) => staticCategoriesTimeseriesFunc(args[0])
    },
    [CustomVisitorEnum.addTotalSeriesVisitor]: {
        visitor: (args) => addTotalSeriesVisitorFunc(args)
    },
    [CustomVisitorEnum.addTotalFlatLineSeriesVisitor]: {
        visitor: (args) => addTotalFlatLineSeriesVisitorFunc(args)
    }
};
